import { render } from "./PostCloseConnectV2.vue?vue&type=template&id=9389069c"
import script from "./PostCloseConnectV2.vue?vue&type=script&lang=js"
export * from "./PostCloseConnectV2.vue?vue&type=script&lang=js"

import "./PostCloseConnectV2.vue?vue&type=style&index=0&id=9389069c&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__